<template>
  <v-app id="inspire">
    <v-container fluid fill-height v-if="!isSignedIn">
      <v-layout align-center justify-center>
        <amplify-authenticator :auth-config="authConfig"></amplify-authenticator>
      </v-layout>
    </v-container>

    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      fixed
      app
      v-if="isSignedIn"
    >
      <v-list dense>
        <template v-for="item in items">
          <v-layout
            v-if="item.heading"
            :key="item.heading"
            row
            align-center
          >
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ item.text }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
            <v-list-tile
              v-for="(child, i) in item.children"
              :key="i"

            >
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  <router-link :to="child.to">
                    {{ child.text }}
                  </router-link>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else :key="item.text">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                <router-link :to="item.to">
                  {{ item.text }}
                </router-link>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      color="blue darken-3"
      dark
      app
      fixed
      v-if="isSignedIn"
    >
      <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <span class="hidden-sm-and-down">Buyback Request</span>
      </v-toolbar-title>
      <!--v-text-field
        flat
        solo-inverted
        hide-details
        prepend-inner-icon="search"
        label="Search"
        class="hidden-sm-and-down"
      ></v-text-field-->
      <v-spacer></v-spacer>
      <div>
        <b>{{environment}}</b> v{{version}}
      </div>
      <!--<v-btn icon>
        <v-icon>apps</v-icon>
      </v-btn> -->
      <v-btn icon>
        <v-icon>notifications</v-icon>
      </v-btn>
      <v-btn icon large>
        <v-avatar size="32px" tile >
          <v-img
              :src="require('./assets/logo.svg')"
              alt="MDSi Inc"
          ></v-img>
        </v-avatar>
      </v-btn>
    </v-toolbar>
    <v-content
        v-if="isSignedIn"
    >
      <v-breadcrumbs :items="$store.state.breadcrumbs" divider=">"></v-breadcrumbs>
      <v-container fluid style="padding: 0px;">
        <v-layout justify-center align-center>
          <router-view />
        </v-layout>
      </v-container>
    </v-content>
    <v-btn
      fab
      bottom
      right
      color="pink"
      dark
      fixed
      @click="dialog = !dialog"
      v-show="$store.state.isSignedIn"

    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" width="800px">
      <RequestEditorModal v-on:save="onSaveRequest" v-on:close="onCloseRequestEditor" :modelOpened="dialog"/>
    </v-dialog>
  </v-app>
</template>
<style>
  button {
    --button-background-color: #1565c0;
    --button-click: #538ACA;
  }

  a {
    text-decoration: none;
    color: black;
  }

  .router-link-exact-active {
    font-weight: bold;
    color: black;
  }

  .environment-text {
    color: rgb(129, 138, 153);
  }

  .logo-image {
    /* background: white; */
    border-radius: 40px;
  }
</style>
<script>
  // import { Auth } from 'aws-amplify'
  import { AmplifyEventBus } from 'aws-amplify-vue'
  import { Auth } from 'aws-amplify'
  import RequestEditorModal from './components/RequestEditorModal'
  import { environment } from './config';
  import { version } from '../package.json';

  export default {
    components: {RequestEditorModal},
    data: () => ({
      isSignedIn: false,
      dialog: false,
      drawer: null,
      isMdsiUser: false,
      isCiscoUser: false,
      environment,
      version,
      authConfig: {
        usernameAttributes: 'email',
        signUpConfig: {
          header: 'Sign up for MDSi Buyback',
          hideAllDefaults: true,
          defaultCountryCode: '1',
          usernameAttributes: 'email',
          signUpFields: [
            {
              label: 'Email',
              key: 'email',
              required: true,
              displayOrder: 1,
              type: 'string',
              signUpWith: true
            },
            {
              label: 'Name',
              key: 'name',
              required: true,
              displayOrder: 2,
              type: 'string',
              signUpWith: true
            },

            {
              label: 'Password',
              key: 'password',
              required: true,
              displayOrder: 4,
              type: 'password'
            }
          ]
        }
      },

      items: [],
    }),
    methods: {
      onSaveRequest(data) {
        // eslint-disable-next-line no-console
        console.log('saveCallback:\n', JSON.stringify(data));
        this.$store.dispatch('SAVE-REQUEST', data);
        this.dialog = false;
      },
      onCloseRequestEditor() {
        this.dialog = false;
      },
      action(item) {
        // eslint-disable-next-line no-console
        console.log('action', item);

        if (item.action === 'logout') {
          this.logout();
        } else if (item.action === 'buyback-request') {
          this.router.push({ name: 'buyback-request' })
        }
      },
      async logout() {
        // eslint-disable-next-line no-console
        console.log('logout user.');
        await Auth.signOut();
        location.reload();
      }
    },
    props: {
      source: String
    },
    async beforeCreate() {
      try {
        console.log('App::beforeCreate - authing user..');
        const user = await Auth.currentAuthenticatedUser();
        console.log('App::beforeCreate - dispatching GET_LOOKUPS..');

        this.$store.dispatch('GET_LOOKUPS');
        this.$store.dispatch('LOAD_PART_NUMBERS');

        console.log('App::beforeCreate - setting user..');

        const self = this;
        // Add administration section if user is in MDSi-User group.
        let isMdsiUser = false, isCiscoUser = false, vendorGroups = [];

        const groups = user.signInUserSession.idToken.payload['cognito:groups'];
        if (groups) {
          isMdsiUser = groups.includes('MDSi-User');
          isCiscoUser = groups.includes('Cisco-User');
        }

        for (let group of groups) {
          if (group.indexOf('Vendor:') === 0) {
            vendorGroups.push(group.split(':')[1]);
          }
        }

        self.isMdsiUser = isMdsiUser;
        self.isCiscoUser = isCiscoUser;
        self.vendorGroups = vendorGroups;
        self.isSignedIn = true;

        const newUser = {...user, vendorGroups, isMdsiUser, isCiscoUser};

        this.$store.dispatch('SET_USER', newUser);
        this.isSignedIn = true;

        this.$store.dispatch('SIGNED_IN', true);
        buildMenu({ isMdsiUser, isCiscoUser, vendorGroups }, this.items);

        if (!isMdsiUser && !isCiscoUser) this.$router.push('user-not-setup');
      } catch (err) {
        console.log('error in App::beforeCreate', err);
        this.isSignedIn = false;
        this.$store.dispatch('SIGNED_IN', false);
      }
      AmplifyEventBus.$on('authState', async (info) => {
        // eslint-disable-next-line no-console
        console.log('authState:', info);
        if (info === 'signedIn') {
          const user = await Auth.currentAuthenticatedUser();

          let isMdsiUser = false, isCiscoUser = false, vendorGroups = [];

          const groups = user.signInUserSession.idToken.payload['cognito:groups'];
          if (groups) {
            isMdsiUser = groups.includes('MDSi-User');
            isCiscoUser = groups.includes('Cisco-User');

            // find vendor groups.

            for (let group of groups) {
              if (group.indexOf('Vendor:') === 0) {
                vendorGroups.push(group.split(':')[1]);
              }
            }
          }

          user.isMdsiUser = isMdsiUser;
          user.isCiscoUser = isCiscoUser;
          user.vendorGroups = vendorGroups;
          self.isMdsiUser = isMdsiUser;
          self.isCiscoUser = isCiscoUser;
          self.vendorGroups = vendorGroups;

          console.log('App::beforeCreate::onAuthState - dispatching GET_LOOKUPS..');

          this.$store.dispatch('GET_LOOKUPS');
          this.$store.dispatch('LOAD_PART_NUMBERS');

          console.log('App::beforeCreate::onAuthState - setting user..');

          this.$store.dispatch('SET_USER', user);
          this.isSignedIn = true;
          this.$store.dispatch('SIGNED_IN', true);

          buildMenu({ isMdsiUser, isCiscoUser, vendorGroups }, this.items);

          if (isMdsiUser || isCiscoUser) {
            this.isSignedIn = true;
            this.$store.dispatch('SIGNED_IN', true);
            this.$router.push('buyback-requests');
          } else if (vendorGroups.length) {
            this.isSignedIn = true;
            this.$store.dispatch('SIGNED_IN', true);
            this.$router.push('vendor-dashboard');
          }
        } else {
          console.log('Setting isSignedIn false.');
          this.$store.dispatch('SIGNED_IN', false);
          this.isSignedIn = false;
        }
      });
    },
  }

  function buildMenu(claims, items) {
    items.push({ icon: 'fa-chart-pie', text: 'Home', action: 'home', to: '/' });

    const allUserMenuItems =  [
          { icon: 'sync', text: 'BuyBack Requests', action: 'buyback-request', to: '/buyback-requests' },
          // { icon: 'attach_money', text: 'Pricing Requests', to: '/pricing-requests' },
          { icon: 'fa-barcode', text: 'Serial Updates', to: '/serial-updates' },
        ];

        const adminMenuItem = {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'Administration',
          model: false,
          to: '/',
          children: [
            { icon: 'list', text: 'Item List', action: 'item-list', to: '/admin/item-list' },
            { icon: 'group', text: 'Manage Users', action: 'manage-users', to: '/admin/users' },
            { icon: 'place', text: 'Repair Locations', action: 'repair-locations', to: '/repair-locations' },
            { icon: 'build', text: 'Vendors', action: 'Vendor', to: '/admin/vendor' },
          ]
        };

        console.log('group memebership:', {isMdsiUser: claims.isMdsiUser, isCiscoUser: claims.isCiscoUser});
        console.log('claims:', claims);

        if (claims.vendorGroups.length > 0) items.push({ icon: 'table_chart', text: 'Vendor Dashboard', to: '/vendor-dashboard' });
        if (claims.isMdsiUser || claims.isCiscoUser) items.push(...allUserMenuItems);
        if (claims.isMdsiUser) items.push(adminMenuItem);

        items.push({ icon: 'exit_to_app', text: 'Logout', action: 'logout', to: '/logout' });
  }
</script>
